import React, { useContext, useState, useEffect } from "react";
import { Row, Col, Card, Form, Input, Button, Checkbox, Select } from "antd";
import { LocationsContext } from "../../context/LocationContext";
import { CompanyContext } from "../../context/CompanyContext";
import { GenericContext } from "../../context/genericContext";
import { Link, useHistory, useParams } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import {
  COMPANY_ROUTE,
  UPDATE_COMPANY_ROUTE,
  PERMISSIONS,
} from "../../constants";
const CompanyForm = () => {
  const { id, dataid } = useParams();
  const history = useHistory();
  const paramid = id || dataid;
  const [isLoading, setLoading] = useState(false);
  const [isActivated, setActivated] = useState(true);
  const [locationData, setLocationData] = useState([]);
  const { locationsList, getLocationsList } = useContext(LocationsContext);
  const { singleCompany, getSingleCompany, createCompany, updateCompany } =
    useContext(CompanyContext);
  const { getUserPermission, userPermissions } = useContext(GenericContext);
  const UpdateAccess = PERMISSIONS.find(
    (x) => x.route === UPDATE_COMPANY_ROUTE.replace("/:id", "")
  );
  const [form] = Form.useForm();
  const handleFormFinish = () => {
    const credentials = form.getFieldsValue();
    credentials["is_active"] = isActivated;
    setLoading(true);
    if (id) {
      updateCompany(credentials, id, (res) => {
        setLoading(false);
        if (res.status) {
          history.push(COMPANY_ROUTE);
        }
      });
    } else {
      createCompany(credentials, (res) => {
        setLoading(false);
        if (res.status) {
          history.push(COMPANY_ROUTE);
        }
      });
    }
  };
  useEffect(() => {
    if (paramid) {
      getSingleCompany(paramid);
    }
    getUserPermission();
    getLocationsList(1, false, "");
  }, []);

  useEffect(() => {
    setLocationData(
      Array.isArray(locationsList) ? locationsList : locationsList.data
    );
  }, [locationsList]);
  useEffect(() => {
    if (singleCompany && paramid) {
      form.setFieldsValue({
        name: singleCompany.name,
        code: singleCompany.code,
        location_id: singleCompany.location_id,
      });
      setActivated(singleCompany.is_active);
    }
  }, [singleCompany]);
  return (
    <div className="layout-content">
      <Row gutter={[24, 0]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          {userPermissions.includes(UpdateAccess.access) && (
            <>
              {dataid && (
                <div style={{ textAlign: "right" }}>
                  <Link to={UPDATE_COMPANY_ROUTE.replace(":id", paramid)}>
                    <Button className="filter-btn">Edit</Button>
                  </Link>
                </div>
              )}
            </>
          )}
          <Card
            bordered={false}
            className="criclebox cardbody "
            style={{ padding: "20px 40px" }}
          >
            <Form form={form} className="form" onFinish={handleFormFinish}>
              <Row gutter={[24, 0]}>
                <Col xs={24} md={12} lg={8}>
                  <label className="form-lbl">Name:</label>
                  <Form.Item
                    name={"name"}
                    rules={[
                      {
                        required: true,
                        message: "Name can't be empty",
                      },
                    ]}
                  >
                    <Input
                      name="name"
                      disabled={dataid}
                      placeholder=""
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={8}>
                  <label className="form-lbl">Code:</label>
                  <Form.Item
                    name={"code"}
                    rules={[
                      {
                        required: true,
                        message: "Code can't be empty",
                      },
                    ]}
                  >
                    <Input
                      name="code"
                      disabled={dataid}
                      placeholder=""
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={8}>
                  <label className="form-lbl">Location:</label>
                  <Form.Item
                    name={"location_id"}
                    rules={[
                      {
                        required: true,
                        message: "please select location",
                      },
                    ]}
                  >
                    <Select
                      placeholder=""
                      name="location_id"
                      disabled={dataid}
                      className="form-select"
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {locationData.map((data, index) => (
                        <Select.Option value={data.id} key={index}>
                          {data.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  lg={8}
                  style={{ display: "flex", alignItems: "flex-end" }}
                >
                  <Form.Item name={"is_active"}>
                    <Checkbox
                      name="is_active"
                      defaultChecked={isActivated}
                      onChange={() => {
                        setActivated(!isActivated);
                      }}
                      disabled={dataid}
                    />
                    <label className="form-sublbl">Is Active?</label>
                  </Form.Item>
                </Col>
                {!dataid && (
                  <Col xs={24} md={24} lg={24}>
                    <Form.Item>
                      <Button
                        htmlType="submit"
                        disabled={isLoading}
                        className="form-btn"
                      >
                        {isLoading ? (
                          <ScaleLoader
                            color={"#FFF"}
                            loading={isLoading}
                            height={14}
                            width={2}
                          />
                        ) : id ? (
                          "Update"
                        ) : (
                          "Create"
                        )}
                      </Button>
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CompanyForm;
